import { paginatedQuery } from 'lib-shared-api-utils';
import { PaginatedApiArg } from 'lib-shared-types-api';

import { api } from 'app/app.api';

import {
  ReadGroupedIpsBansApiResponse,
  ReadGroupedUsersBansApiResponse,
  ReadUserBansApiArg,
  ReadUserBansApiResponse,
  UpdateIpAddressBanApiArg,
  UpdateIpAddressBanApiResponse,
  UpdateIpAddressUnbanApiArg,
  UpdateIpAddressUnbanApiResponse,
  UpdateUserBanApiArg,
  UpdateUserBanApiResponse,
  UpdateUserUnbanApiArg,
  UpdateUserUnbanApiResponse,
} from './types/bansApi.types';

export const bansApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readGroupedUsersBans: builder.query<
      ReadGroupedUsersBansApiResponse,
      PaginatedApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, () => ({
          version: 1,
          path: 'bans/users/grouped/user',
        })),
    }),
    readGroupedIpsBans: builder.query<
      ReadGroupedIpsBansApiResponse,
      PaginatedApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, () => ({
          version: 1,
          path: 'bans/users/grouped/ip',
        })),
    }),
    readUserBans: builder.query<ReadUserBansApiResponse, ReadUserBansApiArg>({
      query: ({ userId, includeInactive }) => ({
        version: 1,
        path: `bans/user/${userId}`,
        params: includeInactive ? { includeInactive: true } : undefined,
      }),
    }),
    updateUserBan: builder.mutation<
      UpdateUserBanApiResponse,
      UpdateUserBanApiArg
    >({
      query: ({ userId, ...body }) => ({
        version: 1,
        method: 'PATCH',
        path: `bans/user/${userId}/ban`,
        body,
      }),
    }),
    updateUserUnban: builder.mutation<
      UpdateUserUnbanApiResponse,
      UpdateUserUnbanApiArg
    >({
      query: ({ userId, ...body }) => ({
        version: 1,
        method: 'PATCH',
        path: `bans/user/${userId}/unban`,
        body,
      }),
    }),
    updateIpAddressBan: builder.mutation<
      UpdateIpAddressBanApiResponse,
      UpdateIpAddressBanApiArg
    >({
      query: ({ ipAddress, ...body }) => ({
        version: 1,
        method: 'PATCH',
        path: `bans/ip/${ipAddress}/ban`,
        body,
      }),
    }),
    updateIpAddressUnban: builder.mutation<
      UpdateIpAddressUnbanApiResponse,
      UpdateIpAddressUnbanApiArg
    >({
      query: ({ ipAddress, ...body }) => ({
        version: 1,
        method: 'PATCH',
        path: `bans/ip/${ipAddress}/unban`,
        body,
      }),
    }),
  }),
});
